import * as React from "react";
import {connect} from "react-redux";
import {RootState} from "../../../store/reducer/root/RootState";
import {none, option, Option} from "ts-option";
import Site from "../../../model/site/Site";
import {getSite} from "../../../store/view/site";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {default as DropDownList, DropDownItem} from "../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import TextUtils from "../../../utils/TextUtils";
import AddressSelectionComponent from "../../address/select/AddressSelectionComponent";
import Address from "../../../model/address/Address";
import SiteData from "../../../model/site/SiteData";
import {OnSuccessData} from "../../../store/action/actionHelpers";
import {createSite} from "../../../store/action/site/site";
import Toast from "../../helper/Toast";
import {Dispatch} from "redux";
import Job from "../../../model/job/Job";
import {editJob} from "../../../store/action/job/job";

interface ComponentProps {
	/**
	 * Job.
	 */
	job: Option<Job>
}

interface ReduxProps {
	/**
	 * Job site.
	 */
	site: Option<Site>
}

interface IDispatchProps {
	/**
	 * Edit job action.
	 * @param {Job} job
	 */
	editJob: (job: Job) => void;
	/**
	 * Create site action.
	 * @param {SiteData} site site data to send.
	 * @param {OnSuccessData<Site>} onSuccess on site creation success callback.
	 */
	createSite: (site: SiteData, onSuccess: OnSuccessData<Site>) => void

}

interface IState {
	/**
	 * Menu dropdown visibility.
	 */
	menuDropDownVisible: boolean;
	/**
	 * Search dropdown visibility.
	 */
	searchBoxVisible: boolean;
}


type Props = ComponentProps & ReduxProps & IDispatchProps

class JobSiteAddress extends React.PureComponent<Props, IState> {
	selectedSiteMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Remove"},
		{id: "l3", label: "Copy"},
	];

	emptySiteMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
	];

	constructor(props: Props) {
		super(props);
		this.state = {
			menuDropDownVisible: false,
			searchBoxVisible: false
		};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onAddressSelect = this.onAddressSelect.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	}

	render() {
		const menuItems = this.props.site.isDefined ? this.selectedSiteMenu : this.emptySiteMenu;

		return (
			<InfoModule icon={Icon.Site} title={"SITE ADDRESS"} actionIcon={Icon.Overflow} onActionIconClick={this.toggleMenu}>
				{this.state.menuDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({menuDropDownVisible: false})}>
					<DropDownList items={menuItems}
								  itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.searchBoxVisible &&
				<DropDownWrapper onOutsideClick={this.handleOutsideClick}>
					<AddressSelectionComponent onSelect={this.onAddressSelect}
											   placeholder={"Search address"}
											   visible={true}
											   focus={true}/>
				</DropDownWrapper>}
				{
					this.props.site.map(site => {
						return (
							<span className="t-body">{site.data.address.displayName()}</span>
						)
					}).getOrElse(<span className="t-body">No site selected</span>)
				}
			</InfoModule>
		);
	}

	handleOutsideClick() {
		const target = event.target as HTMLElement;
		const cssClasses = ["Select-clear", "Select-clear-zone", "c-select-option-text", "c-select-option-desc", "Select-option",
			"c-select-option"];

		if (!cssClasses.some(i => target.classList.contains(i))) {
			this.setState({searchBoxVisible: false});
			return;
		}
	}

	onMenuItemSelect(item: DropDownItem) {
		this.setState({menuDropDownVisible: false, searchBoxVisible: false});
		switch (item.id) {
			case "l1":
				this.setState({searchBoxVisible: true, menuDropDownVisible: false});
				break;
			case "l2":
				this.setState({searchBoxVisible: false, menuDropDownVisible: false}, this.removeSite);
				break;
			case "l3":
				this.props.site.map(c => TextUtils.copyToClipboard(c.data.address.displayName()));
				break;
		}
	}

	toggleMenu() {
		this.setState({menuDropDownVisible: !this.state.menuDropDownVisible, searchBoxVisible: false})
	}

	onAddressSelect(address: Address) {
		this.setState({menuDropDownVisible: false, searchBoxVisible: false}, () =>
			this.props.job.map(l => {
				this.props.createSite(new SiteData(address), (site) => {
					const updatedJob = l.copy({data: l.data.copy({siteId: option(site.id)})});
					this.props.editJob(updatedJob);
				})
			})
		);
	}

	removeSite() {
		this.props.job.map(j => {
			const updatedJob = j.copy({data: j.data.copy({siteId: none})});
			this.props.editJob(updatedJob);
		})
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	return {
		site: props.job.flatMap(job => job.data.siteId.flatMap(sId => getSite(sId, state)))
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		createSite: (site: SiteData, onSuccess: OnSuccessData<Site>) => dispatch(
			createSite(site, onSuccess, () => {Toast.error("Sorry, something went wrong. Try again later.", "Site create")})
		),
		editJob: (job: Job) => dispatch(
			editJob(
				job,
				() => Toast.success("Job contact updated", "Job details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Job details update"))
		),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(JobSiteAddress)